import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import EstimateSection from '../components/estimate/EstimateSection';
import BusSlider from '../components/main/busSlider';
import UseNotice from '../components/main/useNotice';

/**
 * 메인 화면. 배너 + 견적요청(일반/통근 탭) + 버스안내 + 이용안내.
 * PC/모바일 구분 없이 하나의 반응형 화면을 사용한다.
 */
const Main = () => {
  useEffect(() => {
    document.title = '버스대절 전세버스 관광버스 견적 | 이케이하나관광';
  }, []);

  return (
    <Box component='main'>
      {/* 배너 */}
      <Box
        sx={{
          position: 'relative',
          minHeight: { xs: 180, sm: 260, md: 420 },
          backgroundImage:
            "linear-gradient(rgba(94, 94, 94, 0.35), rgba(255, 255, 255, 0.25)), url('/image/main.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            component='h1'
            sx={{
              fontSize: { xs: 20, sm: 28, md: 40 },
              fontWeight: 800,
              color: '#5A4231',
              textShadow: '0 2px 8px rgba(255,255,255,0.8)',
              wordBreak: 'keep-all',
            }}
          >
            전세버스 · 관광버스 · 통근버스 대절
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { xs: 13, sm: 16, md: 20 },
              fontWeight: 700,
              color: '#5A4231',
              backgroundColor: 'rgba(255, 250, 203, 0.75)',
              borderRadius: '10px',
              display: 'inline-block',
              px: 2,
              py: 0.8,
              wordBreak: 'keep-all',
            }}
          >
            모든 지역에서 최상의 서비스로 안전하게 모십니다.
          </Typography>
        </Box>
      </Box>

      {/* 견적 요청 (일반 / 통근 탭) */}
      <Box sx={{ px: { xs: 1.5, md: 3 } }}>
        <EstimateSection />
      </Box>

      {/* 버스 안내 */}
      <BusSlider />

      {/* 이용 안내 */}
      <UseNotice />
    </Box>
  );
};

export default Main;
